import { createSelector } from '@reduxjs/toolkit';
import { selectClaimsItems } from 'store/slices/claimsSlice';

import { ALL_FLEETS } from './channels';

const FLEETS_RESOURCE = 'fleets';

export const selectAccessibleFleetIds = createSelector([selectClaimsItems], claims => {
    const fleetIds = new Set<string>();

    for (const claim of claims) {
        const [resource, , id] = claim.split(':');
        if (resource !== FLEETS_RESOURCE || !id) {
            continue;
        }
        if (id === ALL_FLEETS) {
            return [ALL_FLEETS];
        }
        fleetIds.add(id);
    }

    return [...fleetIds].sort();
});
